import { createSignal } from '@funtech-int/rival';
import { useSignal } from '@funtech-int/rival-react';

import type { AcceptFullscreenPayload } from '@/shared/types/notifications';

export const infoBlockFullscreenNotificationReactiveVar = createSignal<
    AcceptFullscreenPayload | undefined
>(undefined);

export const useInfoBlockFullscreenNotificationReactiveVar = () =>
    useSignal(infoBlockFullscreenNotificationReactiveVar);
